import React, { Component } from "react"
import JSZip from "jszip"
import { Button, Modal, Icon } from "semantic-ui-react"

/**
 * ProductImageDownloader
 *
 * Global component to download all product images as a ZIP file.
 * Probes the image API starting at index 1, stopping on the first 404.
 *
 * Props:
 *   articles: Array<{ id: string, title?: string }>
 *             Each entry represents one article. `id` is used in the image URL.
 */
export default class ProductImageDownloader extends Component {
  state = {
    modalOpen: false,
    loading: false,
    done: 0,
  }

  open = () => this.setState({ modalOpen: true })
  close = () => this.setState({ modalOpen: false })

  fetchArticleImages = async (articleId, size) => {
    const config = window.__bshop_config
    const images = []
    let num = 1
    while (num <= 50) {
      const url = `${config.MEDIA}_/${articleId}/${num}?size=${size}`
      try {
        const res = await fetch(url, { credentials: "include" })
        if (!res.ok) break
        const blob = await res.blob()
        images.push({ num, blob })
        num++
      } catch (e) {
        break
      }
    }
    return images
  }

  download = async (size) => {
    const { articles } = this.props
    console.log("Downloading images for articles", articles, "with size", size)
    this.setState({ modalOpen: false, loading: true, done: 0 })

    const zip = new JSZip()

    for (let i = 0; i < articles.length; i++) {
      const { id } = articles[i]
      if (!id) continue
      const images = await this.fetchArticleImages(id, size)
      images.forEach(({ num, blob }) => {
        zip.file(`${id}_${num}.jpg`, blob)
      })
      this.setState({ done: i + 1 })
    }

    const blob = await zip.generateAsync({ type: "blob" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "artikelbilder.zip"
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    this.setState({ loading: false })
  }

  render() {
    const { modalOpen, loading, done } = this.state
    const { articles } = this.props
    const total = articles ? articles.length : 0

    if (loading) {
      return (
        <div className="flex items-center pv2">
          <Icon name="spinner" loading />
          <span className="ml2 f6">
            {translate("Artikelbilder werden geladen...")} ({done}/{total})
          </span>
        </div>
      )
    }

    return (
      <div>
        <Button primary id="downloadImagesButton"
          style={{ borderRadius: "35px" }}
          onClick={this.open}
        >
          <Icon name="download" />
          <p className="f7 fw5">{translate("Artikelbilder herunterladen")}</p>
        </Button>

        <Modal
          open={modalOpen}
          onClose={this.close}
          size="tiny"
          style={{ position: "fixed", top: "10%", }}
        >
          <Modal.Header>{translate("Bildgröße auswählen")}</Modal.Header>
          <Modal.Content>
            <p>
              {translate(
                "Wählen Sie die Größe der herunterzuladenden Artikelbilder. Die Bilder werden als ZIP-Datei gespeichert."
              )}
            </p>
          </Modal.Content>
          <Modal.Actions style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
            
            <Button primary onClick={() => this.download("middle")}>
              <Icon name="download" />{translate("Mittlere Größe")}
            </Button>
            <Button primary onClick={() => this.download("large")}>
              <Icon name="download" />{translate("Große Größe")}
            </Button>
            <Button onClick={this.close} style={{ borderRadius: "35px" }}>{translate("Abbrechen")}</Button>
          </Modal.Actions>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/util/ProductImageDownloader.js